"use client"

import Link from "next/link"
import { ShoppingBag, User } from "lucide-react"
import { useCart } from "@/lib/cart-store"

export function CustomerNav({
  slug,
  restaurantName,
  subtitle,
  logoSrc,
  titleClassName,
  subtitleClassName,
}: {
  slug: string
  restaurantName: string
  subtitle?: string
  logoSrc?: string
  /** Tipografia do nome no cabeçalho. Cada tenant tem a sua. */
  titleClassName?: string
  subtitleClassName?: string
}) {
  const { totalItens, hydrated } = useCart()
  const headerSubtitle = subtitle ?? "Casa de Comidas · Bombarral"
  const logo = logoSrc ?? `/${slug}-logo.png`

  return (
    <>
      <header
        className="sticky top-0 z-30 hairline-b"
        style={{
          backgroundColor: "color-mix(in srgb, var(--ph-bg) 92%, transparent)",
          backdropFilter: "blur(12px)",
        }}
      >
        <div className="max-w-5xl mx-auto px-5 py-3 flex items-center justify-between">
          <Link
            href={`/r/${slug}`}
            className="flex items-center gap-3 group min-h-[44px]"
            style={{ color: "var(--ph-ink)" }}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={logo}
              alt={restaurantName}
              className="h-9 w-auto object-contain"
              onError={(e) => {
                ;(e.currentTarget as HTMLImageElement).style.display = "none"
              }}
            />
            <div className="leading-tight">
              <div
                className={titleClassName ?? "font-fraunces italic font-bold text-lg"}
                style={{ color: "var(--ph-ink)" }}
              >
                {restaurantName}
              </div>
              <div
                className={subtitleClassName ?? "mono-label"}
                style={{ fontSize: "9px", marginTop: "2px" }}
              >
                {headerSubtitle}
              </div>
            </div>
          </Link>

          <Link
            href={`/r/${slug}/perfil`}
            aria-label="A minha conta"
            className="flex items-center justify-center min-h-[44px] min-w-[44px]"
            style={{ color: "var(--ph-primary)" }}
          >
            <User strokeWidth={1.5} size={22} />
          </Link>
        </div>
      </header>

      {hydrated && totalItens > 0 && (
        slug === "doner-king" ? (
          <Link
            href={`/r/${slug}/carrinho`}
            aria-label={`Ver carrinho com ${totalItens} itens`}
            className="coin-cart-btn bottom-7 left-1/2 -translate-x-1/2 z-40"
          >
            <span className="coin-inner">
              <span className="coin-content">
                <span className="coin-badge">{totalItens}</span>
                <span className="coin-text">Ver Carrinho</span>
                <ShoppingBag strokeWidth={2.4} className="coin-icon" />
              </span>
            </span>
          </Link>
        ) : (
          <Link
            href={`/r/${slug}/carrinho`}
            aria-label={`Ver carrinho com ${totalItens} itens`}
            className="brutal-cart-btn bottom-5 left-1/2 -translate-x-1/2 z-40"
          >
            <span className="brutal-face brutal-static">
              <span className="brutal-badge" aria-hidden>
                {totalItens}
              </span>
              <span className="brutal-text">Ver Carrinho</span>
              <ShoppingBag strokeWidth={2} className="brutal-icon" />
            </span>
            <span className="brutal-face brutal-hover" aria-hidden>
              <span className="brutal-badge brutal-badge-hover">{totalItens}</span>
              <span className="brutal-text">Ver Carrinho</span>
              <ShoppingBag strokeWidth={2} className="brutal-icon" />
            </span>
          </Link>
        )
      )}
    </>
  )
}
